var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcademica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0774 36.8585L17.1604 29.2759L41.0774 21.6934L65.0001 29.2759L41.0774 36.8585Z",
    stroke: "#17B6CA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3686 32.2969V48.5739C56.3686 48.5739 52.6719 53.073 41.3525 53.073C30.033 53.073 26.1013 48.5739 26.1013 48.5739V32.2969",
    stroke: "#17B6CA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.78 30.5713V50.9004",
    stroke: "#17B6CA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0092 53.2273C22.0092 53.6966 21.8701 54.1553 21.6094 54.5455C21.3486 54.9357 20.978 55.2398 20.5445 55.4194C20.1109 55.599 19.6338 55.646 19.1735 55.5545C18.7133 55.4629 18.2905 55.2369 17.9586 54.9051C17.6268 54.5732 17.4008 54.1505 17.3093 53.6902C17.2177 53.2299 17.2647 52.7528 17.4443 52.3193C17.6239 51.8857 17.928 51.5151 18.3182 51.2544C18.7084 50.9937 19.1672 50.8545 19.6365 50.8545C19.9481 50.8545 20.2566 50.9159 20.5445 51.0351C20.8324 51.1544 21.0939 51.3291 21.3143 51.5495C21.5346 51.7698 21.7094 52.0314 21.8286 52.3193C21.9479 52.6071 22.0092 52.9157 22.0092 53.2273V53.2273Z",
    stroke: "#17B6CA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7194 57.8525C18.7194 57.8525 17 60.4546 17 62.9477H22.6912C22.6912 62.9477 22.2327 59.3026 20.9374 57.8525",
    stroke: "#17B6CA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M41.5 23L20 28.8723L41 35.5L63 28.8723L41.5 23Z",
    fill: "#17B6CA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M41.0716 37.7413L26.7432 33.1562V48.0578C26.7432 48.0578 29.0357 52.3563 41.3581 52.3563C53.6805 52.3563 55.6865 48.0578 55.6865 48.0578V33.1562L41.0716 37.7413Z",
    fill: "#17B6CA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#17B6CA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademica);
export default __webpack_public_path__ + "static/media/academica.01fe8bf1fc0db9791b9c07d411ae094a.svg";
export { ForwardRef as ReactComponent };